<app-header>
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
</app-header>
<mat-toolbar class="main-toolbar cf-flex-row cf-justify-content-end" color="primary"></mat-toolbar>
<div class="main-content">
  <div class="loading cf-flex-row cf-justify-content-center">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
</div>
